import { EntranceTrackerPage } from '@/components/entrance-tracker/entrance-tracker-page';

export function EntrancesPage() {
  return <EntranceTrackerPage />;
}
